import { twMerge } from 'tailwind-merge';

interface MediaNotFoundProps {
  icon?: React.ReactNode;
  notFoundText?: string;
  containerClassName?: string;
  defaultIconClassName?: string;
}

export const MediaNotFound = ({
  icon,
  notFoundText,
  containerClassName,
  defaultIconClassName,
}: MediaNotFoundProps) => {
  const renderErrorElement = (text: string) => {
    return (
      <div className="flex items-center gap-1.5">
        <i className="ki-outline ki-information-1 text-purple-400 text-xl" />
        <div className="text-white font-medium">{text}</div>
      </div>
    );
  };

  return (
    <div
      className={twMerge(
        'absolute inset-0 w-full h-full bg-blue-131025',
        containerClassName
      )}
    >
      <div className="h-full flex flex-col justify-center items-center">
        {icon || (
          <i
            className={twMerge(
              'ki-outline ki-picture text-white text-[70px]',
              defaultIconClassName
            )}
          />
        )}
        {notFoundText && (
          <div className="mt-3">{renderErrorElement(notFoundText)}</div>
        )}
      </div>
    </div>
  );
};
